import React from 'react';
// Constants
import {
  FETLIFE_URL,
  I_WANT_CLIPS_URL,
  LOYALFANS_URL,
  MANY_VIDS_URL,
  MINTSTARS_URL,
  SEXT_PANTHER_URL,
  TWITTER_URL,
} from '../../utils/Constants';
// Images
import LoyalFansIcon from '../../assets/images/icons/loyalfans-icon-no-background.png';
import ManyVidsIcon from '../../assets/images/icons/manyvids-icon.png';
import FetlifeIcon from '../../assets/images/icons/fetfile-icon-no-background.png';
import SextIcon from '../../assets/images/icons/sext-panther-icon-no-background.png';
// Icons
import { FaTwitter } from 'react-icons/fa';

export const smallFanSitesArray = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    logo: LoyalFansIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'I Want Clips',
    url: I_WANT_CLIPS_URL,
    icon: <div className='text-colour7'>IWC</div>,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'SextPanther',
    url: SEXT_PANTHER_URL,
    logo: SextIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
];

export const fanSitesArray = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    logo: LoyalFansIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'I Want Clips',
    url: I_WANT_CLIPS_URL,
    icon: <div className='text-colour7'>IWC</div>,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'SextPanther',
    url: SEXT_PANTHER_URL,
    logo: SextIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'FetLife',
    url: FETLIFE_URL,
    logo: FetlifeIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
  {
    name: 'Twitter',
    icon: <FaTwitter className='text-6xl' />,
    url: TWITTER_URL,
    description: 'Follow to Me and see My exclusive links.',
  },
];

export const socialMediaBigPinArray = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    logo: LoyalFansIcon,
    description:
      'Premium fetish content with direct interaction and exclusive perks.',
  },
];
